
<template>
  <div class="insight-filter-item">
    <div class="insight-filter-item-title">{{title}}</div>
    <div class="insight-filter-item-contents" @click="handleClick">
      <span v-for="(item, index)  in  filterItemData" :key="index" :id="item.name"  :class="{active: item.name === activeName}">
        {{item.name}}
      </span>
    </div>
  </div>
</template>
<script>
export default {
  data(){
     return {
       activeName: '不限'
     };
  },
  props: {
    title: String,
    filterItem: Array
  },
  computed: {
    filterItemData: function () {
     return [{name: '不限'}].concat(this.filterItem)
    }
  },
  methods: {
    handleClick (event) {
  
      if(event.srcElement.tagName !== 'SPAN' ) return
      this.activeName = this.filterItemData.find(ele => ele.name === event.srcElement.id).name
      this.$emit('changeitem', event.srcElement.id)
    }
  }
}
</script>

<style lang="scss">
 .insight-filter-item {
   display: flex;
   align-items: center;
   justify-content: flex-start;

   >.insight-filter-item-title {
         font-size: 14px;
    color: #999999;
    letter-spacing: 0;
    font-weight: 400;
    margin-right: 28px;
    width: 85px;
    text-align: right;
}
>.insight-filter-item-contents {
  font-size: 14px;
    color: #333333;
    letter-spacing: 0;
    font-weight: 400;
    display: flex;
    flex-wrap: wrap;
   >span {
     margin-right: 27px;
      &:hover {
        cursor: pointer;
      }   
    }
}
   .active {
     color: #0C84F0;
   }

 }
</style>